/**
 * Asynchronously loads the component for NoticePage
 */

import { lazyLoad } from "@utils/loadable";

export const NoticePage = lazyLoad(
  () => import("./index"),
  (module) => module.NoticePage
);
